import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';
import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import { capitalize } from '../../../util/util';
import { StyledSectionContainer } from '../../common';
import DisplayCard from '../../DisplayCard';

interface Props {
	cancellationData: CancellationData;
	authData: AuthData;
}

const ReinstatementOverview = (props: Props) => {
	const { authData, cancellationData } = props;
	const { selectedCancellation } = cancellationData;

	const renderDetailCard = (title: string, data: string) => {
		return <DisplayCard title={title} value={data} />;
	};

	return (
		<StyledSectionContainer>
			<Stack spacing={2}>
				<Typography id='reinstatement_id' variant='h3' gutterBottom>
					{`Reinstatement ${selectedCancellation.reinstatement.locator}`}
				</Typography>
				<Stack direction='row' spacing={2}>
					{renderDetailCard('Cancellation Id', selectedCancellation.locator)}
					{renderDetailCard(
						'Cancellation Created',
						authData.getFormattedDate(selectedCancellation.createdTimestamp),
					)}
					{renderDetailCard(
						'Cancellation Name',
						capitalize(selectedCancellation.title),
					)}
					{renderDetailCard(
						'Cancellation State',
						capitalize(selectedCancellation.state),
					)}
					{renderDetailCard(
						'Reinstatement Created',
						authData.getFormattedDate(
							selectedCancellation.reinstatement.createdTimestamp,
						),
					)}
					{renderDetailCard(
						'Reinstatement Last Modified',
						authData.getFormattedDate(
							selectedCancellation.reinstatement.updatedTimestamp,
						),
					)}
					{renderDetailCard(
						'Reinstatement Status',
						capitalize(selectedCancellation.reinstatement.state),
					)}
				</Stack>
			</Stack>
		</StyledSectionContainer>
	);
};

export default withCancellationContext<Props>(ReinstatementOverview);
